import { combineReducers } from 'redux';

import AuthReducer from '../components/auth/auth_reducer';
import ProjectReducer from '../components/project/project_reducer';
import TimerReducer from '../components/timetracker/timer_reducer';
import CommonReducer from '../common/common_reducer';


const rootReducer = combineReducers({
  auth: AuthReducer,
  projects: ProjectReducer,
  timer: TimerReducer,
  common: CommonReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/reducers.js